import { HardTokenAddController } from '../hard-token-add.controller';

export class Controller extends HardTokenAddController {

    /** @ngInject */
    constructor($state,HardTokenService,Alert) {
        super($state,HardTokenService,Alert);
    }

    $onInit() {
        super.$onInit();
        this.type = 'THIRD_PARTY';
        this.otpType = 'TOTP';
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/hard-token-management/hard-token-add/hotp-totp-add/hotp-totp-add.controller.js